<footer class="footer bg-dark">
    <div class="row">
        <div class="col-sm-4 footer-left">
            <a href="{{'footer.link' | translate}}" translate>footer.copyright</a>
        </div>
        <div class="col-sm-4 footer-center">
            <a href="{{'footer.link' | translate}}" target="_blank"><img src="assets/img/company-logo.png"
                    height="34" /></a>
        </div>
        <div class="col-sm-4 footer-right">
            <a [routerLink]=undefined class="clickable" (click)="disclaimerDlg()" translate>footer.disclaimer</a>
            &bull;
            <a [routerLink]=undefined class="clickable" (click)="cookiesDlg()" translate>footer.cookies</a>
        </div>
    </div>
</footer>